import { PerksClassDesignWizardState } from 'core/application/adminDashboard/benefitDetails/design/perks/productClass/getPerksProductClassDesignWizardState'

import { NavItemProps } from '../../../../common/productClassWizardModal/models'
import SelectPerks, { SelectPerksProps } from './selectPerks'
import SetAllowances, { SetProductClassAllowancesProps } from './setAllowances'
import SetEligibleCategories, { SetEligibleExpensesProps } from './setEligibleCategories'
import SetWaitingPeriod, { SetWaitingPeriodProps } from './setWaitingPeriod'

export enum PerksProductClassWizard {
  SelectPerks = 'perks-class-design-select-perks',
  SetEligibleCategories = 'perks-class-design-select-eligible-categories',
  SetAllowances = 'perks-class-design-set-allowances',
  SetWaitingPeriod = 'perks-class-design-set-waiting-period',
}

export const PerksProductClassWizardNavItemsMapping: NavItemProps[] = [
  {
    key: PerksProductClassWizard.SelectPerks,
    component: SelectPerks,
    nextButtonTooltip:
      'admin-dashboard.benefit-details.class-design.select-class.modal-steps-tooltip.perks.select-perks-tooltip',
    mapState: (state: PerksClassDesignWizardState | undefined): SelectPerksProps => {
      return {
        id: state ? state.id : '',
        perksIds: state ? state.perksIds : [],
      }
    },
  },
  {
    key: PerksProductClassWizard.SetAllowances,
    component: SetAllowances,
    nextButtonTooltip:
      'admin-dashboard.benefit-details.class-design.select-class.modal-steps-tooltip.perks.set-allowances-tooltip',
    mapState: (state: PerksClassDesignWizardState | undefined): SetProductClassAllowancesProps => {
      return {
        id: state ? state.id : '',
        offerSameAllowance: state ? state.offerSameAllowance : false,
        categoryAllowances: state ? state.categoryAllowances : [],
      }
    },
  },
  {
    key: PerksProductClassWizard.SetEligibleCategories,
    component: SetEligibleCategories,
    nextButtonTooltip:
      'admin-dashboard.benefit-details.class-design.select-class.modal-steps-tooltip.perks.set-eligible-categories-tooltip',
    mapState: (state: PerksClassDesignWizardState | undefined): SetEligibleExpensesProps => {
      return {
        id: state ? state.id : '',
        eligibleCategoryIds: state ? state.eligibleCategoryIds : [],
      }
    },
  },
  {
    key: PerksProductClassWizard.SetWaitingPeriod,
    component: SetWaitingPeriod,
    nextButtonTooltip:
      'admin-dashboard.benefit-details.class-design.select-class.modal-steps-tooltip.perks.set-waiting-period-tooltip',
    mapState: (state: PerksClassDesignWizardState | undefined): SetWaitingPeriodProps => {
      return {
        id: state ? state.id : '',
        waitingPeriod: state ? state.waitingPeriod : null,
      }
    },
  },
]
